import "./interfaces.d.ts";

import * as React from "react";
import { Row, Col } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { userInfoStore } from "Stores/UserInfoStore";
import { projectGroupList } from "Pages/Admin/Stores/ProjectGroupStore";
import { DisplayAPIError } from "Components/General/DisplayAPIError";
import { observer } from "mobx-react";
import { AdminCard } from "Pages/Admin/Pages/Dashboard/Components/AdminCard";
import { GenericCard } from "Pages/Project/Components/GenericCard";
import { ReportCard } from "./Components/ReportCard";
import { I18N_NS } from "Config/i18n";
import { customerTextBlockStore } from "../CustomerInfo/CustomerTextBlockStore";
import { UserInterfaceCard } from "./Components/UserInterfaceCard";
import { AdminSysInfoReport } from "./Components/AdminSysInfoReport";
import { oXConfigStore } from "Pages/Admin/Stores/OXConfigStore";
import { releaseNotesStore } from "../ReleaseNotes/ReleaseNotesStore";

interface InjectedTranslateProps extends WithTranslation {}

export const AdminDashboard = withTranslation(I18N_NS.ADMIN)(
  observer(
    class extends React.Component<InjectedTranslateProps> {
      componentDidMount() {
        (async () => {
          if (userInfoStore.role === "PRGROUPADMIN") {
            await projectGroupList.fetch();
          }
          if (userInfoStore.role === "ADMIN") {
            await releaseNotesStore.fetch();
            await customerTextBlockStore.fetch();
            await oXConfigStore.fetchOxAdminStatus();
          }
        })();
      }

      render() {
        const { t } = this.props;
        const sysAdminMainSection: AdminDashboardSection = {
          title: "Create and edit",
          tools: [
            {
              label: "Users",
              link: "/admin/user",
            },
            {
              label: "Accounts",
              link: "/admin/accounts",
            },
            {
              label: "Project Groups",
              link: "/admin/projectgroup",
            },
            {
              label: "Projects",
              link: "/admin/projects",
            },
            {
              label: "Print Service Providers",
              link: "/admin/service-providers",
            },
            {
              label: "Signature for emails from sys admins",
              link: "/admin/email-signature",
            },
            {
              label: "Project templates",
              link: "/admin/templates",
            },
            {
              label: "SSO Server",
              link: "/admin/sso",
            },
            {
              label: "Files in download area",
              link: "/admin/support-files",
            },
            {
              label: "System roles",
              link: "/admin/system-roles",
            },
            {
              label: "External Applications",
              link: "/admin/external-applications",
            },
            {
              label: "Feature flags",
              link: "/admin/feature-flags",
            },
            {
              label: "MCP",
              link: "/admin/mcp",
            },
          ],
          roles: ["ADMIN"],
        };
        const sysAdminApprovalsSection: AdminDashboardSection = {
          title: "Approvals",
          tools: [
            {
              label: "Project roles to users",
              link: "/admin/project-access",
            },
          ],
          roles: ["ADMIN"],
        };

        const prGroupAdminMainSection: AdminDashboardSection = {
          title: "Customer self-administration",
          tools: [],
          roles: ["PRGROUPADMIN"],
        };

        const cardLayout = (
          <GenericCard>
            <h1>{t("Administration")}</h1>
            {userInfoStore.role === "ADMIN" ? (
              <Row gutter={16} style={{ marginTop: "1rem" }}>
                <Col xs={24} md={8}>
                  <AdminCard {...sysAdminMainSection} />
                  <AdminSysInfoReport />
                </Col>
                <Col xs={24} md={16}>
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <AdminCard {...sysAdminApprovalsSection} />
                    </Col>
                    <Col xs={24} md={12}>
                      <ReportCard />
                    </Col>
                    <Col xs={24} md={24}>
                      <UserInterfaceCard />
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : null}
            {userInfoStore.role === "PRGROUPADMIN" && (
              <Row gutter={16} style={{ marginTop: "1rem" }}>
                <Col xs={24} md={8} key={prGroupAdminMainSection.title}>
                  <AdminCard {...prGroupAdminMainSection} />
                </Col>
              </Row>
            )}
          </GenericCard>
        );

        if (userInfoStore.role === "PRGROUPADMIN") {
          return (
            <DisplayAPIError store={projectGroupList} state="state">
              {cardLayout}
            </DisplayAPIError>
          );
        } else {
          return cardLayout;
        }
      }
    }
  )
);
